/**
 * Created by Abhishek Singhal on 23/9/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {TombOfNefertitiParsedGameData} from "../../server/data/TombOfNefertitiParsedGameData";

export class TombOfNefertitiInitCurseRespinController extends WinPresentationController {

    public static HIGHLIGHT_FIRST_CURSE_REEL:string = "highlightFirstCurseReel";

    private _finishTimeoutId:number;

    constructor(indexes:[number, number]) {
        super(indexes, {name : 'yellowFire'});
    }

    protected hasWin():boolean {
        return !!(this._gameData && this._gameData.betWins.length > 0 && (this._gameData as TombOfNefertitiParsedGameData).isCurseFeatureReSpinTriggered);
    }

    protected startWinPresentation():void {
        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiInitCurseRespinController.HIGHLIGHT_FIRST_CURSE_REEL));
        this._finishTimeoutId = window.setTimeout(this.finish.bind(this), 500);
    }

    protected stopWinPresentation(isAborted:boolean):void {
        clearTimeout(this._finishTimeoutId);
    }
}